module.exports = __webpack_public_path__ + "img/18.68c5bbe0.svg";